module.exports = __webpack_public_path__ + "static/assets/5acf8e400edef92553b494e10c38bc95.png";